(function () {
  document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth >= 750) return;

    const searchModal = document.querySelector(".search-modal__content");
    if (!searchModal) return;

    // Add class to searchModal for CSS targeting
    searchModal.classList.add("has-scroll-shadow");

    const possibleScrollContainers = [
      document.querySelector(".predictive-search__scroll-container"),
      document.querySelector(".predictive-search"),
      searchModal,
    ].filter(Boolean);

    possibleScrollContainers.forEach((element) => {
      element.addEventListener(
        "scroll",
        function (e) {
          if (e.target.scrollTop > 5) {
            searchModal.classList.add("is-scrolled");
          } else {
            searchModal.classList.remove("is-scrolled");
          }
        },
        { passive: true },
      );
    });

    let resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        if (window.innerWidth >= 750) {
          searchModal.classList.remove("is-scrolled");
        }
      }, 150);
    });
  });
})();
